import * as Yup from "yup";
import datetime from "config/datetime";
import { Variants } from "types";

export const BOTH_SIDES = "Both";

export type AddOneRepMaxSide = Variants | typeof BOTH_SIDES;

export interface AddOneRepMaxFormValues {
  createdDate: string;
  side: AddOneRepMaxSide | null;
  weight: number | "";
}

export function generateAddOneRepMaxSchema(options: { imperialSystemEnabled: boolean; hasVariants: boolean }) {
  const { imperialSystemEnabled, hasVariants } = options;
  const unitSuffix = imperialSystemEnabled ? "imperial" : "metric";

  return Yup.object({
    createdDate: Yup.string()
      .required("global.error_required_field")
      .test("valid-date", "charting.one_rep_max_add_dialog_entry_date_error_invalid", (value) =>
        datetime(value).isValid()
      )
      // The picker's disableFuture only greys out calendar days; a typed date still reaches the form.
      .test(
        "not-future",
        "charting.one_rep_max_add_dialog_entry_date_error_future",
        (value) => !datetime(value).isAfter(datetime(), "day")
      ),
    side: hasVariants
      ? Yup.mixed<AddOneRepMaxSide>()
          .oneOf([Variants.Left, Variants.Right, BOTH_SIDES])
          .required("global.error_required_field")
      : Yup.mixed<AddOneRepMaxSide>().nullable(),
    weight: Yup.number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .required("global.error_required_field")
      .positive(`athlete_profile1rm_edit.form_weight_error_positive_${unitSuffix}`)
      .max(imperialSystemEnabled ? 1350 : 600, `athlete_profile1rm_edit.form_weight_error_max_${unitSuffix}`),
  });
}
